// Stored role name → display label. The DB/API keep "Finance" as the role
// key throughout (roles table, audit log entries, assign/revoke payloads) -
// this is a UI-only rename, matching db/roles_store.py's note that no data
// migration was done. Route every place a role name reaches the screen
// through this map rather than hard-coding "Approver" per component.
const ROLE_LABELS: Record<string, string> = {
  Admin: "Admin",
  Finance: "Finance Approver",
};

export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

/** Roles capped at one holder org-wide - mirrors
 *  db/roles_store.py's SINGLE_HOLDER_ROLES (currently empty: Admin and
 *  Finance are both uncapped). Used client-side to disable granting a
 *  role to a second person before the request round-trips. */
export const SINGLE_HOLDER_ROLES: string[] = [];
